import React from 'react';
import { CssBaseline, Grid } from '@material-ui/core';

import axiosInstance, { checkDeadline, EVENT_CODE, getEventId, setScrollPosition, WEB_API } from '../constatns';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import RegistrationSubmissionForm from './RegistrationSubmissionForm';
import swal from '@sweetalert/with-react';

class RegistrationSubmission extends React.Component {
  componentDidMount() {
    setScrollPosition(0);

    // if (sessionStorage.getItem('_in_role') !== 'SCRL_MGR') {
    //   this.props.history.push('/registration/submission');
    //   window.location.reload();
    // }
    // if (!sessionStorage.getItem('_in_user_')) {
    //   this.props.history.push('/signin');
    // }
    if (sessionStorage.getItem('EVENT')) {
      if (!checkDeadline('regDeadline2')) {
        swal('Online registration period has ended.');
        this.props.history.push('/main');
      } else {
        if (!sessionStorage.getItem('_in_user_')) {
          this.props.history.push('/signin');
        }
      }
    } else {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
            if (!checkDeadline('regDeadline2')) {
              swal('Online registration period has ended.');
              this.props.history.push('/main');
            } else {
              if (!sessionStorage.getItem('_in_user_')) {
                this.props.history.push('/signin');
              }
            }
          }
        });
    }
  }

  movePage = (url) => {
    if (url) this.props.history.push(url);
    else this.props.history.goBack();
  };

  render() {
    // const { classes } = this.props;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={3} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Online Registration</MainTitle>
            </Grid>

            <RegistrationSubmissionForm movePage={this.movePage.bind(this)} isRepayment={true} />
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default RegistrationSubmission;
